<script setup lang="ts">
/**
 * The Footer Price
 * --------------------------------
 * Shows a price in the footer (if set)
 */

const { price, priceType } = useFooterState();
</script>

<template>
    <div v-if="price && price.amount > 0" class="mr-2 flex h-full items-center border-shade-2 pr-4 typo-heading-md max-md:border-r">
        <span>
            <span>{{ priceType === 'STARTING_PRICE' ? $t('core.startingPrice') : '' }}</span> <span data-t-footer-price>{{ formatPrice(price) }}</span>
        </span>
    </div>
</template>
